var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-menu',{attrs:{"bottom":"","offset-y":"","transition":"slide-y-transition","origin":"center center","close-on-content-click":false},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-btn',_vm._g({attrs:{"icon":"","text":""}},on),[_c('v-icon',[_vm._v("mdi-dots-grid")])],1)]}}])},[_c('v-card',[_c('app-menu')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }